const STORAGE_KEY = 'ggj_b2b_client_new_wizard_draft';

export type ClientNewWizardDraftV1 = {
  v: 1;
  orgId: string;
  step: number;
  maxReached: number;
  form: {
    name: string;
    domain: string;
    industry: string;
    contact_name: string;
    contact_email: string;
    contact_phone: string;
    commercial_agreement_label: string;
    mou_reference: string;
    contract_start_date: string;
    contract_end_date: string;
    commercial_terms_summary: string;
    notes: string;
  };
  consentAccepted: boolean;
  engagementScrolledToEnd: boolean;
  savedAt: string;
};

export function loadClientNewWizardDraft(orgId: string): ClientNewWizardDraftV1 | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as ClientNewWizardDraftV1;
    if (p?.v !== 1 || p.orgId !== orgId || typeof p.step !== 'number') return null;
    return p;
  } catch {
    return null;
  }
}

export function saveClientNewWizardDraft(payload: ClientNewWizardDraftV1): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...payload, savedAt: new Date().toISOString() }));
  } catch {
    /* quota / private mode */
  }
}

export function clearClientNewWizardDraft(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
